import { LineSpacingIcon } from "components/common/Icons/LineSpacingIcon";
import { Slider } from "components/common/Slider/Slider";
import { setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

interface LineSpacingProps {
    textBox: TextBox;
}

export const LineSpacing = ({ textBox }: LineSpacingProps) => {
    const dispatch = useAppDispatch();
    function handleChange(value: number) {
        dispatch(
            setSettings({
                id: textBox.id,
                spacing: {
                    ...textBox.spacing,
                    line: value,
                },
            }),
        );
    }
    return (
        <div className="flex gap-[31px] items-center text-black dark:text-white">
            <div>
                <LineSpacingIcon />
            </div>
            <div className="w-full">
                <Slider
                    defaultValue={textBox.spacing.line}
                    value={textBox.spacing.line}
                    handleChange={handleChange}
                    max={3}
                    min={1}
                    step={0.25}
                    width={85}
                />
            </div>
            <div className="text-sm px-2.5 border border-irGray-200 dark:border-darkSurface-400 rounded-lg">
                {textBox.spacing.line}
            </div>
        </div>
    );
};
